// extracted by mini-css-extract-plugin
export default {"main_image_container":"About_main_image_container__cqcqd","about_main_line":"About_about_main_line__kvKp2"};